import cookies from './cookies';

export default function getCartUrl(domain: string | undefined): string {
  const VITE_APP_MODE = import.meta.env.MODE;
  const NODE_ENV = process.env.NODE_ENV?.toLowerCase();
  const isDevMode = import.meta.env.DEV;

  
  // Check if the hostname contains a subdomain
  const isSubdomain = domain && domain.split('.').length > 2;
  const separator = isSubdomain ? '-' : '.';
  
  let rootUrl = `https://dlcart${separator}${domain}`;

  if (VITE_APP_MODE === 'localDev' && isDevMode) {
    rootUrl = `https://cart${separator}${domain}`;
  }
  if (VITE_APP_MODE === 'staging' && isDevMode) {
    rootUrl = `https://mlcart${separator}${domain}`;
  }

  if (NODE_ENV === 'staging') {
    rootUrl = `https://mlcart${separator}${domain}`;
  }
  if (NODE_ENV === 'production') {
    rootUrl = `https://cart${separator}${domain}`;
  }


  const updateQueryString = (uri: string, key: string, value: string) => {
    let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    let separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return uri + separator + key + '=' + value;
    }
  };

  let checkoutUrl = `${rootUrl}/cart`;

  if (cookies.get('cartId')) {
    checkoutUrl = updateQueryString(checkoutUrl, 'cartId', cookies.get('cartId') || '');
  }
  if (cookies.get('bulk')) {
    checkoutUrl = updateQueryString(checkoutUrl, 'bulk', cookies.get('bulk') || '');
  }

  return checkoutUrl;
}
